import React, { useState } from 'react';
import {
  Typography,
  Box,
  Paper,
  Container,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import { PageHeader } from '../common/PageHeader';
import {
  ExpandMore as ExpandMoreIcon,
  ArrowBack as ArrowBackIcon,
  Home as HomeIcon,
  Circle as CircleIcon,
  ArrowRight as ArrowRightIcon,
  NavigateNext as NavigateNextIcon,
  MonitorHeart as MonitorHeartIcon,
  Help as HelpIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const VideoEditingHelpPage = ({darkMode, toggleDarkMode, themeVariant}) => {

  

  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Box sx={{
                width: '100%',
                backgroundColor: darkMode ? 'background.default' : '#f5f5f5',
                minHeight: '100vh',
            }}>
      <Paper sx={{
        borderRadius: 0,
        padding: 0
      }}>
      <PageHeader 
        darkMode={darkMode} 
        toggleDarkMode={toggleDarkMode}
        themeVariant={themeVariant} 
      />
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, padding: 1 }}>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<HomeIcon />}
            onClick={() => navigate('/')}
            sx={{ mr: 2 }}
          >
            Home
          </Button>
          {/* Add arrow icon between buttons */}
          <NavigateNextIcon sx={{ mx: 1, color: 'text.secondary', fontSize: 20 }} />
          <Button
            variant="text"
            color="primary"
            startIcon={<MonitorHeartIcon />}
            sx={{ mr: 2 }}
          >
            Support
          </Button>
          <NavigateNextIcon sx={{ mx: 1, color: 'text.secondary', fontSize: 20 }} />
          <Button
            variant="text"
            color="primary"
            startIcon={<HelpIcon />}
            sx={{ mr: 2 }}
          >
            Help
          </Button>
        </Box>
      <Box sx={{ mx: 'auto', p: { xs: 1, sm: 2, md: 3 } }}>
        <Box sx={{ mx: 'auto', p: { xs: 1, sm: 2, md: 3 } }}>          
          <Paper sx={{ p: 3, mb: 4 }}>
            <Box sx={{ mb: 3 }}>
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="editing-english-content"
                  id="editing-english-header"
                >
                  <Typography variant="subtitle1" fontWeight="medium">Editing English Subtitles</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box sx={{ mb: 2 }}>
                    <Box sx={{ 
                      mb: 3, 
                      textAlign: 'center',
                      borderRadius: 1,
                      overflow: 'hidden',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                    }}>
                      <img 
                        src="/help_EditingView.png" 
                        alt="Editing Subtitles" 
                        style={{ maxWidth: '100%', height: 'auto' }}
                      />
                    </Box>
                    
                    <Typography variant="h6" gutterBottom sx={{ 
                      borderBottom: '1px solid',
                      borderColor: theme => theme.palette.divider,
                      pb: 0.5,
                      mb: 2
                    }}>
                      Subtitle Editing Pane and Top Bar
                    </Typography>
                    
                    <List sx={{ 
                      pl: 0,
                      '& .MuiListItem-root': {
                        alignItems: 'flex-start',
                        py: 1
                      },
                      '& .MuiListItemIcon-root': {
                        minWidth: '28px',
                        mt: '4px'
                      }
                    }}>
                      <ListItem>
                        <ListItemIcon>
                          <CircleIcon sx={{ fontSize: 8, color: theme => theme.palette.primary.main }} />
                        </ListItemIcon>
                        <ListItemText 
                          primary="Home Button: Takes you the root of the directory" 
                          primaryTypographyProps={{ fontWeight: '500' }}
                        />
                      </ListItem>
                      
                      <ListItem>
                        <ListItemIcon>
                          <CircleIcon sx={{ fontSize: 8, color: theme => theme.palette.primary.main }} />
                        </ListItemIcon>
                        <ListItemText 
                          primary="Folder Name: Clicking on this will take you the directory where this video is"
                          primaryTypographyProps={{ fontWeight: '500' }}
                        />
                      </ListItem>
                      
                      <ListItem>
                        <ListItemIcon>
                          <CircleIcon sx={{ fontSize: 8, color: theme => theme.palette.primary.main }} />
                        </ListItemIcon>
                        <ListItemText 
                          primary="Language Selection"
                          primaryTypographyProps={{ fontWeight: '500' }}
                          secondary="Select the language you want to edit, this needs to match the language that you have selected in the root directory. The root directory language selection is shown at the top of the 'Video Pane'. If the editing language does not match the root directory language, the changes will not be saved."
                        />
                      </ListItem>
                      
                      {/* ...remaining English subtitle editing instructions... */}
                    </List>
                    
                    <Typography variant="h6" gutterBottom sx={{ 
                      borderBottom: '1px solid',
                      borderColor: theme => theme.palette.divider,
                      pb: 0.5,
                      mt: 3,
                      mb: 2
                    }}>
                      Timeline Pane
                    </Typography>
                    
                    <List sx={{ 
                      pl: 0,
                      '& .MuiListItem-root': {
                        alignItems: 'flex-start',
                        py: 0.75
                      },
                      '& .MuiListItemIcon-root': {
                        minWidth: '28px',
                        mt: '4px'
                      }
                    }}>
                      {/* ...timeline pane instructions... */}
                    </List>
                    
                    <Typography variant="h6" gutterBottom sx={{ 
                      borderBottom: '1px solid',
                      borderColor: theme => theme.palette.divider,
                      pb: 0.5,
                      mt: 3,
                      mb: 2
                    }}>
                      Video Pane
                    </Typography>
                    
                    <List sx={{ 
                      pl: 0,
                      '& .MuiListItem-root': {
                        alignItems: 'flex-start',
                        py: 0.75
                      },
                      '& .MuiListItemIcon-root': {
                        minWidth: '28px',
                        mt: '4px'
                      }
                    }}>
                      <ListItem>
                        <ListItemIcon>
                          <CircleIcon sx={{ fontSize: 8, color: theme => theme.palette.primary.main }} />
                        </ListItemIcon>
                        <ListItemText primary="Play and Pause the video: Use Tab to play and pause the video or the Play button on the video" />
                      </ListItem>
                    </List>
                  </Box>
                </AccordionDetails>
              </Accordion>
              
              <Accordion sx={{ mt: 2 }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="editing-language-content"
                  id="editing-language-header"
                >
                  <Typography variant="subtitle1" fontWeight="medium">Editing Language Subtitles</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box sx={{ mb: 2 }}>
                    <Box sx={{ 
                      mb: 3, 
                      textAlign: 'center', 
                      borderRadius: 1,
                      overflow: 'hidden',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                    }}>
                      <img 
                        src="/help_EditingLangSubtitles.png" 
                        alt="Editing Language Subtitles" 
                        style={{ maxWidth: '100%', height: 'auto' }}
                      />
                    </Box>
                    
                    <List sx={{ 
                      pl: 0,
                      '& .MuiListItem-root': {
                        alignItems: 'flex-start',
                        py: 1
                      },
                      '& .MuiListItemIcon-root': {
                        minWidth: '28px',
                        mt: '4px'
                      }
                    }}>
                      {/* ...language subtitle editing instructions... */}
                    </List>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </Box>
          </Paper>
        </Box>
      </Box>
      </Paper>
    </Box>
  );
};

export default VideoEditingHelpPage;